import React from "react";
import { StarFilled } from "@ant-design/icons";
import "./Spinner.scss"

const RatingLayout = function ({name,rating,color}) {
    return <div className="flex" style={{border:`1px solid ${color}`, margin:"0px 10px"}}> 
   
   {name && <div className="p10" style={{color}}>
    {name}
    </div>
}
    <div className="flex p10 badge-icon" style={{background:color}}>
        <div>{rating}</div>
<StarFilled  className="ml-sm" />

</div>  

      </div>;
  };
  export default RatingLayout;